import { useEffect, useState } from "react";
import { fetchNotUploadedStats } from "../api";

export function StatsView() {
  const [dates, setDates] = useState<string[]>([]);
  const [selectedDate, setSelectedDate] = useState<string | "">("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [items, setItems] = useState<{ uploader: string; count: number }[]>([]);

  const loadData = async (date?: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchNotUploadedStats(date);
      setDates(data.dates);
      setSelectedDate(data.selectedDate ?? "");
      setItems(data.items);
    } catch (err) {
      setError(err instanceof Error ? err.message : "加载失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void loadData();
  }, []);

  const handleDateChange = (value: string) => {
    setSelectedDate(value);
    void loadData(value || undefined);
  };

  return (
    <section className="panel">
      <h2>按天统计上传数量</h2>
      <div className="field inline">
        <label>日期</label>
        <select
          value={selectedDate}
          onChange={(e) => handleDateChange(e.target.value)}
        >
          <option value="">全部</option>
          {dates.map((date) => (
            <option key={date} value={date}>
              {date}
            </option>
          ))}
        </select>
      </div>
      {loading && <p>加载中...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && (
        <table className="stats-table">
          <thead>
            <tr>
              <th>姓名</th>
              <th>当日上传数量</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.uploader}>
                <td>{item.uploader}</td>
                <td>{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}

